"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToPlayerVsTeamMatchup = void 0;
function mapToPlayerVsTeamMatchup(response, player, team, eventId) {
    const playerGrade = {
        rank: response.playerGradeRank,
        totalRank: response.playerGradeRankTotal,
        grade: response.playerGradeValue,
        facet: response.playerFacet,
    };
    const teamGrade = {
        rank: response.teamGradeRank,
        totalRank: response.teamGradeRankTotal,
        grade: response.teamGradeValue,
        facet: response.teamFacet,
    };
    const result = {
        player: player,
        playerGrade: playerGrade,
        opponent: team,
        teamGrade: teamGrade,
        matchupScore: response.matchupScore,
        eventId: eventId,
    };
    return result;
}
exports.mapToPlayerVsTeamMatchup = mapToPlayerVsTeamMatchup;
//# sourceMappingURL=player_team_matchup_request.js.map